import Auth from "./Auth";

class LMSUser {
	static async getAllByLMS(lmsID) {
		const result = {};
		const session = Auth.getSession();

		if (session) {
			try {
				const response = await fetch(`${process.env.REACT_APP_BASE_URL}/api/admin/${session.idAdmin}/lms/${lmsID}/users`,
					{
						method: "GET",
						headers: {
							"Authorization": `Bearer ${session.token}`,
							"Content-Type": "application/json"
						}
					}
				);

				if (response.ok) {
					result.data = await response.json();

					if (!Array.isArray(result.data)) {
						result.data = [];
					}
				}

				result.status = response.status;
			} catch (error) {
				result.status = (error.response) ? error.response.status : 500;
			}
		} else {
			result.status = 401;
		}

		return result;
	}

	static async delete(lmsID, id, userID, threeDeeAppId) {
		const result = {};
		const session = Auth.getSession();

		if (session) {
			try {
				const query = new URLSearchParams({
					idUsr: userID,
					idApp3D: threeDeeAppId
				}).toString();

				const response = await fetch(`${process.env.REACT_APP_BASE_URL}/api/admin/${session.idAdmin}/lms/${lmsID}/users/${id}?${query}`,
					{
						method: "DELETE",
						headers: {
							"Content-Type": "application/json",
							"Authorization": `Bearer ${session.token}`
						}
					}
				);

				result.status = response.status;
			} catch (error) {
				result.status = (error.response) ? error.response.status : 500;
			}
		} else {
			result.status = 401;
		}

		return result;
	}
}

export default LMSUser;
